import createReducer from 'redux/createReducer';
import { deepFreeze } from 'utils/deepFreeze';

import { LOCATION_CHANGE } from 'redux-first-history';

import {
  pending,
  fulfilled,
  rejected,
  clearError,
  throttleLogins,
  resetSessionState,
  saveShoppingContext,
} from './sessions';

import setAccessToken from './set-access-token';
import setHashedCustomerId from './set-hashed-customer-id';

import {
  CLEAR_ERROR,
  tokenActionTypes,
  shoppingContextActionTypes,
  SET_ACCESS_TOKEN,
  THROTTLE_LOGINS,
  DISABLE_THROTTLE_LOGINS,
  SET_HASHED_CUSTOMER_ID,
} from '../actions/types';

// This may not be correct, created as necessity for recipes/meal-plan and copies the "inferred" types
export type SessionsState = Readonly<{
  accessToken: string;
  loading: boolean;
  error: null;
  customerId: string;
  customerOrderId: string;
  customerOrderState: null;
  defaultBranchId: string;
  expiresIn: null;
  permissions: never[];
  principalId: string;
}>;

export const initialState: SessionsState = deepFreeze({
  // deepcode ignore HardcodedNonCryptoSecret - placeholder
  accessToken: 'Bearer unauthenticated',
  loading: false,
  error: null,
  customerId: '-1',
  customerOrderId: '0',
  customerOrderState: null,
  defaultBranchId: '651',
  expiresIn: null,
  permissions: [],
  principalId: '-1',
  hashedCustomerId: '',
});

const actionTypeReducerMap = new Map([
  [tokenActionTypes.request, pending],
  [tokenActionTypes.success, fulfilled],
  [tokenActionTypes.failure, rejected],
  [shoppingContextActionTypes.request, pending],
  [shoppingContextActionTypes.success, saveShoppingContext],
  [shoppingContextActionTypes.failure, resetSessionState],
  [SET_ACCESS_TOKEN, setAccessToken],
  [LOCATION_CHANGE, clearError],
  [CLEAR_ERROR, clearError],
  [THROTTLE_LOGINS, throttleLogins],
  [DISABLE_THROTTLE_LOGINS, resetSessionState],
  [SET_HASHED_CUSTOMER_ID, setHashedCustomerId],
]);

export default createReducer(initialState, actionTypeReducerMap);
